import T from '../../services/language';
import styled from "styled-components";
import {DatePicker, Input, Select, TimePicker} from "antd";
import {useEffect, useRef, useState} from "react";
import {Header} from "../../components/Header";
import {ContainerView} from "../../components/Container";
import moment from "moment";
import {SkeletonView} from "../../components/Skeleton";
import {fileUrlExacter, formatPhoneNumber, getFileView, hexToRgbA, uploadBigFile} from "../../services/app";
import {useApp} from "../../contexts/app";
import {getCountries, getCountryCallingCode} from 'react-phone-number-input';
import parsePhoneNumberFromString from "libphonenumber-js/min";
import Environment from "../../environment";
import {DivPlaceholder, TextPlaceholder, usePlaceholderLoading} from "../../components/Loading/placeholder";
import {CloseModalIcon, EyeIcon, ViewImageModal, ViewImageModalClose, ViewImageModalImage} from "../Confirm/style";
import List from 'rc-virtual-list';
import produce from "immer";

const CalenderIcon = (props: any) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 2V5" stroke="#626262" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M16 2V5" stroke="#626262" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M3.5 9.08984H20.5" stroke="#626262" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
              stroke="#626262" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M15.6947 13.6992H15.7037" stroke="#626262" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M15.6947 16.6992H15.7037" stroke="#626262" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M11.9955 13.6992H12.0045" stroke="#626262" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M11.9955 16.6992H12.0045" stroke="#626262" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M8.29431 13.6992H8.30329" stroke="#626262" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M8.29431 16.6992H8.30329" stroke="#626262" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
    </svg>
)
const TimerIcon = (props: any) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 22.75C6.76 22.75 2.5 18.49 2.5 13.25C2.5 8.01 6.76 3.75 12 3.75C17.24 3.75 21.5 8.01 21.5 13.25C21.5 18.49 17.24 22.75 12 22.75ZM12 5.25C7.59 5.25 4 8.84 4 13.25C4 17.66 7.59 21.25 12 21.25C16.41 21.25 20 17.66 20 13.25C20 8.84 16.41 5.25 12 5.25Z"
            fill="#626262"/>
        <path
            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
            fill="#626262"/>
        <path
            d="M15 2.75H9C8.59 2.75 8.25 2.41 8.25 2C8.25 1.59 8.59 1.25 9 1.25H15C15.41 1.25 15.75 1.59 15.75 2C15.75 2.41 15.41 2.75 15 2.75Z"
            fill="#626262"/>
    </svg>

)
export const QuestionView = styled.div`
    margin: 28px 0 20px 0px;
`;
export const QuestionHead = styled.div`
    display: flex;
    align-items: flex-start;
`;
export const QuestionHeadIndexRequire = styled((props) => (
    <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.5" y="1.5" width="11" height="11" rx="5.5" fill="white"/>
        <rect x="1.5" y="1.5" width="11" height="11" rx="5.5" stroke="white" strokeWidth="3"/>
        <path
            d="M10.0187 4.216L10.9787 5.92267L8.056 7.01067L10.9787 8.09867L9.99733 9.848L7.56533 7.928L8.01333 11.0213H6.05067L6.456 7.928L4.024 9.89067L3 8.07733L5.90133 6.98933L3 5.944L3.98133 4.19467L6.47733 6.11467L6.05067 3H8.03467L7.56533 6.11467L10.0187 4.216Z"
            fill="#F42222"/>
    </svg>
))`
    position: absolute;
    z-index: 1;
    top: -6px;
    right: -6px;
`;
export const QuestionHeadIndex = styled.div`
    width: 24px;
    height: 24px;
    background-color: ${props => props.theme.main || "#1D896D"};
    margin-right: 12px;
    border-radius: 24px;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    position: relative;
`;
export const QuestionHeadContent = styled.div`
    flex: 1;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #101820;
`;
export const QuestionBody = styled.div`
    margin: 20px 0;

    & .ant-picker-cell-today .ant-picker-cell-inner:before {
        border-radius: 8px;
    }
`;

export const InputView = styled(Input.TextArea)`
    background: #FFFFFF;
    border: 1px solid #BEBEBE;
    border-radius: 10px;
    padding: 13px 16px;
    font-size: 16px;
`;

const MultiSelectContainer = styled.div`
    & > div:last-child {
        margin-bottom: 0;
    }
`;
const MultiSelectItem = styled.div`
    padding: 12px 16px;
    min-height: 50px;
    border: 1px solid #DDDDDD;
    border-radius: 8px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &.active {
        background: ${props => hexToRgbA(props.theme.main || "#40A68C", 0.1)};
        border: 1px solid ${props => props.theme.main || "#40A68C"};
        color: ${props => props.theme.main || "#1D896D"};
    }
`;
const MultiSelectItemContent = styled.div`
    flex: 1;
    margin-right: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const MultiSelectItemIcon = styled.div`
    width: 20px;
    height: 20px;

    svg {
        width: 20px;
        height: 20px;
    }
`;

export const MultiSelect = (props: any) => {
    const options = props.options || [];
    const value = props.value || [];
    const type = props.type === 'single' ? 'single' : 'multi'
    const onChange = props.onChange;

    const checked = (item) => {
        return !!value?.find(x => x.key === item.key);
    }

    const onSelect = (item) => {
        if (checked(item)) {
            onChange(value.filter(x => x.key !== item.key)?.map(x => ({
                key: x?.key,
                value: x?.value
            })));
        } else {
            if (type === 'single') {
                onChange([item]?.map(x => ({
                    key: x?.key,
                    value: x?.value
                })));
            } else {
                onChange([...value, item]?.map(x => ({
                    key: x?.key,
                    value: x?.value
                })));
            }
        }
    }

    return (
        <MultiSelectContainer>
            {
                options?.map((item, index, array) => {
                    return (
                        <MultiSelectItem className={checked(item) ? 'active' : ""} onClick={() => onSelect(item)}
                                         key={index.toString()}>
                            <MultiSelectItemContent>{item?.value || ""}</MultiSelectItemContent>
                            <MultiSelectItemIcon>
                                {checked(item) ? (<CheckedBoxIcon type={type}/>) : (<CheckBoxIcon type={type}/>)}
                            </MultiSelectItemIcon>
                        </MultiSelectItem>
                    )
                })
            }
        </MultiSelectContainer>
    )
}

const SearchSelectContainer = styled.div``;
const DateContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    & .ant-picker-date-panel {
        width: auto;
    }

    & .ant-picker-date-panel .ant-picker-content {
        width: 300px;
    }

    & .ant-picker-cell .ant-picker-cell-inner {
        min-width: 32px;
        height: 32px;
        line-height: 32px;
        border-radius: 6px;
`;
const SearchSelectBar = styled.div`
    position: relative;

    & svg {
        margin-right: 8px;
        position: absolute;
        top: 14px;
        left: 12px;
        z-index: 2;
    }

    & input {
        z-index: 1;
        height: 48px;
        background: #FFFFFF;
        border: 1px solid #BEBEBE;
        border-radius: 8px;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #2A2F36;
        padding: 0 12px;
        padding-left: 42px;
    }
`;
const SearchSelectList = styled.div`
    padding: 12px 16px;
    border: 1px solid #DDDDDD;
    border-radius: 8px;
    margin-top: 20px;
`;
const SearchSelectListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;

    & span {
        flex: 1;
        padding-right: 12px;
    }
`;
const SearchSelectModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.main || "#40A68C"};
    display: flex;
    flex-direction: column;
`;

const SearchSelectModalList = styled(List)`
    margin-top: 12px;
`;
const SearchSelectModalListItem = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #101820;
    margin-bottom: 0px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 10px;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
        background: #F1F1F1;
    }
`;


export const SearchSelect = (props: any) => {
    const [modal, setModal] = useState(false);
    const [keyword, setKeyword] = useState("");
    const options = props.options || [];
    const value = props.value || [];
    const onChange = props.onChange;

    const checked = (item) => {
        return !!value?.find(x => x.key === item.key);
    }

    const onSelect = (item) => {
        if (checked(item)) {
            onChange(value.filter(x => x.key !== item.key)?.map(x => ({
                key: x?.key,
                value: x?.value
            })));
        } else {
            onChange([...value, item]?.map(x => ({
                key: x?.key,
                value: x?.value
            })));
        }
        setModal(false)
    }

    return (
        <SearchSelectContainer>
            <SearchSelectBar onClick={() => setModal(true)}>
                <SearchIcon/>
                <Input readOnly={true} autoFocus={false} placeholder={T("Search...")}/>
            </SearchSelectBar>
            {
                value?.length ? (
                    <SearchSelectList>
                        {
                            (value || []).map((item, index, array) => {
                                return (
                                    <SearchSelectListItem key={index.toString()}>
                                        <span>{item?.value || ""}</span>
                                        <RemoveIcon onClick={() => onSelect(item)}/>
                                    </SearchSelectListItem>
                                );
                            })
                        }
                    </SearchSelectList>
                ) : null
            }
            {
                modal ? (
                    <SearchSelectModal>
                        <Header back onBack={() => {
                            setModal(false)
                        }} title={T("Search")}/>
                        <ContainerView style={{flex: 1, paddingLeft: 0, paddingRight: 0, paddingBottom: 0}}>
                            <SearchSelectBar style={{marginLeft: 16, marginRight: 16}} onClick={() => setModal(true)}>
                                <SearchIcon/>
                                <Input value={keyword} onChange={(event) => setKeyword(event.target.value)}
                                       autoFocus={true} placeholder={T("Search...")}/>
                            </SearchSelectBar>
                            <SearchSelectModalList
                                itemHeight={40}
                                itemKey={"id"}
                                data={(options || []).filter(x => x?.value?.toString()?.toLowerCase()?.includes(keyword?.toLowerCase())).map((item, index) => {
                                    return {...item, id: index}
                                })}
                                styles={{
                                    verticalScrollBar: {visibility: 'hidden', width: 0},
                                    verticalScrollBarThumb: {visibility: 'hidden'}
                                }}
                                height={window.innerHeight - 120}
                                style={{paddingLeft: 16, paddingRight: 16}}>
                                {
                                    (item, index) => {
                                        return (
                                            <SearchSelectModalListItem onClick={() => onSelect(item)}
                                                                       key={index.toString()}>
                                                {item?.value || ""}
                                            </SearchSelectModalListItem>
                                        );
                                    }
                                }
                            </SearchSelectModalList>
                        </ContainerView>

                    </SearchSelectModal>
                ) : null
            }
        </SearchSelectContainer>
    )
}

const DatePickerView = styled(DatePicker).attrs({
    showTime: false,
    suffixIcon: (<CalenderIcon/>),
    getPopupContainer: (triggerNode) => triggerNode.parentNode
})`
    &.ant-picker {
        height: 50px;
        background: #FFFFFF;
        border: 1px solid #BEBEBE;
        border-radius: 10px;
        flex: 1;
    }

    & .ant-picker-input > input {
        line-height: 26px;
        height: 26px;
        font-size: 16px;
    }

    & .ant-picker-clear {
        display: none;
    }
`;
const TimePickerView = styled(TimePicker).attrs((props: any) => {
    return {
        inputReadOnly: true,
        placeholder: "00:00",
        format: 'HH:mm',
        onSelect: (event) => props.onChange(event),
        popupClassName: 'custom-picker',
        suffixIcon: (<TimerIcon/>)

    }
})`
    &.ant-picker {
        height: 50px;
        background: #FFFFFF;
        border: 1px solid #BEBEBE;
        border-radius: 10px;
    }

    & .ant-picker-input > input {
        font-weight: 400 !important;
        font-size: 14px;
        line-height: 20px !important;
        color: #494949 !important;
        text-align: center !important;
    }

    & .ant-picker-clear {
        display: none;
    }
`;
const VirtualInput = styled.div`
    flex: 1;
    width: 100%;
    position: relative;
    cursor: pointer;

    & * {
        cursor: pointer !important;

    }

    & > input {
        font-size: 16px;
    }

    & > input.date {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        min-width: 100%;
        width: ${window.innerWidth - 32}px;
        height: 100%;
        opacity: 0;
        flex: 1;
    }

    @media screen and (min-width: 550px) {
        & > input {
            display: none;
        }
    }
`;
export const DateView = (props: any) => {
    const value = props.value || "";
    const onChange = props.onChange;
    const systemDateFormat = 'YYYY-MM-DD';
    const date = value ? (moment(value, Environment.dateFormat).isValid() ? moment(value, Environment.dateFormat) : undefined) : undefined;

    useEffect(() => {
        if (!value) {
            //onChange(moment().format(Environment.dateFormat))
        }
    }, [value])

    const onSubmit = (item) => {
        item ? onChange(item.format(Environment.dateFormat)) : onChange("");
    }

    return (
        <DateContainer>
            <VirtualInput style={{position: "relative", flex: 1, width: "100%"}}>
                <DatePickerView style={{flex: 1, width: "100%"}} format={Environment.dateFormatView}
                                placeholder={Environment.dateFormatView}
                                value={date || undefined}
                                onChange={event => onSubmit(event)}/>
                {/*<input onClick={(event) => {*/}
                {/*    const inputRef: any = event.target;*/}
                {/*    if (inputRef?.showPicker) {*/}
                {/*        inputRef.showPicker();*/}
                {/*    }*/}
                {/*}} type={'date'} value={date ? date.format(systemDateFormat) : ""} className={"date"}*/}
                {/*       onChange={(event) => {*/}
                {/*           onSubmit(moment(`${event.target.value}`, systemDateFormat));*/}
                {/*       }}/>*/}
            </VirtualInput>
            {/*<VirtualInput style={{position: "relative", width: 130, flex: 'none', marginLeft: 16}}>*/}
            {/*    <TimePickerView style={{width: 130}} value={date} onChange={event => onSubmit(event)}/>*/}
            {/*    <input onClick={(event) => {*/}
            {/*        const inputRef: any = event.target;*/}
            {/*        if (inputRef?.showPicker) {*/}
            {/*            inputRef.showPicker();*/}
            {/*        }*/}
            {/*    }} type={'time'} value={date.format('HH:mm')} onChange={(event) => {*/}
            {/*        onSubmit(moment(`${date.format("YYYY-MM-DD")} ${event.target.value}`, 'YYYY-MM-DD HH:mm'));*/}
            {/*    }}/>*/}
            {/*</VirtualInput>*/}
        </DateContainer>
    )
}

const ImageUploadContainer = styled.div``;
export const ImageUploadTitle = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #5D5D5D;
    margin-bottom: 4px;

    span {
        color: #F42222;
    }
`;

const UploadSelector = styled.div`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 13px 16px;
    height: 76px;
    background: ${props => hexToRgbA(props.theme.main, 0.1) || "#F0F8F4"};
    border: 1px dashed ${props => props.theme.main || "#40A68C"};
    border-radius: 10px;
    display: flex;
    cursor: pointer;
    flex: 1;

    &.error {
        border-color: #F42222;
    }

    & span {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        color: #989898;
        margin-top: 6px;
    }

    &.box {
        width: 120px;
        height: 120px;
        flex: none;
        padding: 0;
    }
`;

const Images = styled.div`
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
`;

const ImagePdf = styled.div`
    border-radius: 10px;
    width: 120px;
    height: 120px;
    background: #EAEEF9;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    & > svg {
        position: inherit !important;
    }

    .filename {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #1B1B1B;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        margin-top: 16px;

        span {
            white-space: nowrap;
        }

        & > span:first-child {
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
`;


const Image = styled.div`
    border-radius: 10px;
    width: 120px;
    height: 120px;
    overflow: hidden;
    position: relative;
    flex: none;
    margin-right: 8px;
    background-color: #f4f4f4;

    .ant-skeleton-element {
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.6);
    }

    img {
        width: 120px;
        height: 120px;
        object-fit: cover;
    }

    svg {
        position: absolute;
        z-index: 1;
        top: 6px;
        right: 6px;
        cursor: pointer;
    }

    &.view-only .open {
        position: absolute;
        display: none;
    }

    &.view-only:hover:after {
        width: 100%;
        height: 100%;
        position: absolute;
        content: "";
        z-index: 1;
        background-color: #ffffffc2;
        top: 0;
        left: 0;
        border-radius: 8px;
        border: 1px solid lightgray;
    }

    &.view-only:hover .open {
        display: block;
        top: calc(50% - 12px);
        left: calc(50% - 10px);
        z-index: 2;
        cursor: pointer;
    }
`;

const Error = styled.div`
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #F42222;

    margin-top: 4px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    & span {
        margin-left: 4px;
    }
`;

export const useTemporaryViewLink = () => {
    const filesRef = useRef([]);

    const setFile = (file, viewFile) => {
        if (file && viewFile) {
            filesRef.current.push({
                file: file, viewFile
            })
        }
    }

    const getFile = (file) => {
        return filesRef.current.findLast(x => x.file === file)?.viewFile || file
    }
    return {getLocalFileView: getFile, setFileView: setFile}
}


export const ImageUploadView = (props: any) => {
    const fileRef = useRef<any>();
    const imagesRef = useRef<any>();
    const {value, onChange, required, index, error, onUploading}: any = props;
    const currentValue = value || [];
    const [row, setRow] = useState<any>([]);
    const [typeError, setTypeError] = useState<number>(0);
    const {getLocalFileView, setFileView} = useTemporaryViewLink();
    const [rows, setRows] = useState<any>([]);
    const [rowsView, setRowsView] = useState<any>({});

    useEffect(() => {
        setRows([...(currentValue || []), ...row])
    }, [currentValue, row]);

    useEffect(() => {

    }, [rows]);

    useEffect(() => {
        setTimeout(() => {
            if (imagesRef.current) {
                imagesRef.current.scrollLeft = imagesRef.current?.scrollWidth;
            }
        }, 100);
    }, [currentValue, index]);

    useEffect(() => {
        if (error) {
            setTypeError(1)
        }
    }, [error])

    const loadNewFileView = async (fileUrl: string) => {
        const isPdf = getFileInfo(fileUrl).ext === 'pdf';
        // Check if the file is a PDF or an AWS URL
        if (typeof fileUrl !== 'string' || isPdf || fileUrl.includes('AWSAccessKeyId') || rowsView[fileUrl] === null || !!rowsView[fileUrl]) {
            return;
        }

        setRowsView(produce(draft => {
            draft[fileUrl] = null;
        }));
        const result = await getFileView(fileUrl);
        if (result?.status === 200) {
            try {
                // Save cache url
                window.sessionStorage.setItem(fileUrl, result?.data?.data);
            } catch (e) {
            }
            setRowsView(produce(draft => {
                draft[fileUrl] = result?.data?.data;
            }));
        }
    }

    const onFile = (event) => {
        setRow(prevState => {
            const nextState = [...prevState];
            let fileError = false;
            for (let i = 0; i < event.target.files.length; i++) {
                const file = event.target.files[i];
                if (file.type.includes('pdf') || file.type.includes('jpg') || file.type.includes('jpeg') || file.type.includes('png')) {
                    nextState.push({
                        url: "",
                        base64: URL.createObjectURL(event.target.files[i]),
                        file: event.target.files[i],
                    });
                    onUpload(event.target.files[i], nextState.length - 1).then();
                } else {
                    fileError = true;
                }
            }
            setTypeError(fileError ? 2 : 0);
            fileRef.current.value = "";
            return nextState;
        });
        setTimeout(() => {
            imagesRef.current.querySelector('.add').scrollIntoView({
                behavior: "smooth",
                inline: 'end',
                block: "nearest"
            });
        }, 100);
    }

    const onUpload = async (file, valueInd) => {
        onUploading(true)
        const result: any = await uploadBigFile(file).catch(reason => null);
        try {
            // Save cache url
            window.sessionStorage.setItem(result?.fileUri, result?.fileUriView);
        } catch (e) {
        }
        setFileView(result?.fileUri, result?.fileUriView);
        if (result?.fileUri) {
            onSubmit([...(currentValue || []), result?.fileUri])
        } else {
            setTypeError(3);
        }
        setRow([]);
        onUploading(false)
    }

    const onSubmit = (values: Array<any>) => {
        onChange(values)
    }

    const getFileInfo = (item: any) => {
        let fileName = item?.file?.name || fileUrlExacter(item?.url || "")?.fileName || fileUrlExacter(item).fileName;
        return {
            name: fileName?.split('.')[0],
            ext: fileName?.split('.')[1] || "",
        }
    }


    return (
        <ImageUploadContainer>
            <input multiple={false} type={"file"} onChange={onFile} ref={fileRef} accept=".jpeg, .jpg, .png, .pdf"
                   style={{display: "none"}}/>

            <ImageUploadTitle>Upload image {required ? (<span>*</span>) : null}</ImageUploadTitle>
            <Images className="hide-scroll" ref={imagesRef}>
                {rows?.map((value, index) => {
                    let viewValue = value;
                    let loadingView = false; // Show loading for get file view
                    try {
                        // get cache url
                        if (typeof value === 'string') {
                            const isPdf = getFileInfo(value).ext === 'pdf';
                            const localFileView = window.sessionStorage.getItem(value);
                            if (localFileView) {
                                viewValue = localFileView;
                            }
                            if (rowsView[value]) {
                                viewValue = rowsView[value];
                            }
                            if (rowsView[value] === null && !isPdf) {
                                loadingView = true;
                            }
                        }
                    } catch (e) {
                    }
                    return (
                        <Image key={index.toString()}>
                            {
                                getFileInfo(value).ext === 'pdf' ? (
                                    <ImagePdf>
                                        <PdfIcon/>
                                        <div className={'filename'}>
                                            <span>{window.decodeURIComponent(getFileInfo(value)?.name || "")}</span>
                                            <span>.{getFileInfo(value)?.ext || ""}</span>
                                        </div>
                                    </ImagePdf>
                                ) : (
                                    <img
                                        style={{opacity: 0}}
                                        onLoad={(e: any) => {
                                            e.target.style.opacity = 1;
                                        }}
                                        onError={(e) => {
                                            loadNewFileView(getLocalFileView(value.url) || value.base64 || getLocalFileView(value)).then()
                                        }}
                                        src={getLocalFileView(viewValue.url) || viewValue.base64 || getLocalFileView(viewValue)}
                                    />
                                )
                            }

                            {((!value?.url && typeof value !== "string") || loadingView) ? (
                                <SkeletonView style={{width: 120, height: 120}}/>) : null}

                            {typeof value === 'string' ? (
                                <TrashIcon onClick={() => {
                                    onSubmit(currentValue.filter(x => x !== value))
                                }}/>
                            ) : null}
                        </Image>
                    )
                })}
                <UploadSelector className={`${rows?.length ? "box" : ""} ${typeError ? 'error' : ''} add`}
                                onClick={() => fileRef.current.click()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M22.02 16.8198L18.89 9.49978C18.32 8.15978 17.47 7.39978 16.5 7.34978C15.54 7.29978 14.61 7.96978 13.9 9.24978L12 12.6598C11.6 13.3798 11.03 13.8098 10.41 13.8598C9.77998 13.9198 9.14999 13.5898 8.63999 12.9398L8.41999 12.6598C7.70999 11.7698 6.82999 11.3398 5.92999 11.4298C5.02998 11.5198 4.25998 12.1398 3.74998 13.1498L2.01999 16.5998C1.39999 17.8498 1.45999 19.2998 2.18999 20.4798C2.91999 21.6598 4.18998 22.3698 5.57998 22.3698H18.34C19.68 22.3698 20.93 21.6998 21.67 20.5798C22.43 19.4598 22.55 18.0498 22.02 16.8198Z"
                            fill="#40A68C"/>
                        <path
                            d="M6.97 8.38012C8.83672 8.38012 10.35 6.86684 10.35 5.00012C10.35 3.13339 8.83672 1.62012 6.97 1.62012C5.10327 1.62012 3.59 3.13339 3.59 5.00012C3.59 6.86684 5.10327 8.38012 6.97 8.38012Z"
                            fill="#40A68C"/>
                    </svg>
                    <span>{T('JPG, PNG or PDF')}</span>
                </UploadSelector>
            </Images>

            {
                typeError ? (
                    <Error>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.0067 3.90016L9.04666 1.6135C8.39999 1.24016 7.59999 1.24016 6.94666 1.6135L2.99332 3.90016C2.34666 4.2735 1.94666 4.96683 1.94666 5.72016V10.2802C1.94666 11.0268 2.34666 11.7202 2.99332 12.1002L6.95332 14.3868C7.59999 14.7602 8.39999 14.7602 9.05332 14.3868L13.0133 12.1002C13.66 11.7268 14.06 11.0335 14.06 10.2802V5.72016C14.0533 4.96683 13.6533 4.28016 13.0067 3.90016ZM7.49999 5.16683C7.49999 4.8935 7.72666 4.66683 7.99999 4.66683C8.27332 4.66683 8.49999 4.8935 8.49999 5.16683V8.66683C8.49999 8.94016 8.27332 9.16683 7.99999 9.16683C7.72666 9.16683 7.49999 8.94016 7.49999 8.66683V5.16683ZM8.61332 11.0868C8.57999 11.1668 8.53332 11.2402 8.47332 11.3068C8.34666 11.4335 8.17999 11.5002 7.99999 11.5002C7.91332 11.5002 7.82666 11.4802 7.74666 11.4468C7.65999 11.4135 7.59332 11.3668 7.52666 11.3068C7.46666 11.2402 7.41999 11.1668 7.37999 11.0868C7.34666 11.0068 7.33332 10.9202 7.33332 10.8335C7.33332 10.6602 7.39999 10.4868 7.52666 10.3602C7.59332 10.3002 7.65999 10.2535 7.74666 10.2202C7.99332 10.1135 8.28666 10.1735 8.47332 10.3602C8.53332 10.4268 8.57999 10.4935 8.61332 10.5802C8.64666 10.6602 8.66666 10.7468 8.66666 10.8335C8.66666 10.9202 8.64666 11.0068 8.61332 11.0868Z"
                                fill="#F42222"/>
                        </svg>
                        {
                            typeError === 1 ? (
                                <span>{T('Please upload the supporting images')}</span>
                            ) : null
                        }
                        {
                            typeError === 2 ? (
                                <span>{T('The selected file is not supported')}</span>
                            ) : null
                        }
                        {
                            typeError === 3 ? (
                                <span>{T('Upload image error')}</span>
                            ) : null
                        }
                    </Error>
                ) : null
            }

        </ImageUploadContainer>
    )
}

export const ImagesSampleView = (props: any) => {
    const rows = props.value;
    const [modalImage, setModalImage] = useState("");

    const getFileInfo = (item: any) => {
        let fileName = fileUrlExacter(item)?.fileName;
        return {
            name: fileName?.split('.')[0],
            ext: fileName?.split('.')[1] || "",
        }
    }
    return (
        <ImageUploadContainer style={{marginBottom: 16, marginTop: -6}}>
            <ImageUploadTitle>{T('Sample')}</ImageUploadTitle>
            <Images className="hide-scroll">
                {rows?.map((value, index) => {
                    const isPdf = getFileInfo(value).ext === 'pdf';
                    return (
                        <Image className={"view-only"} key={index.toString()}>
                            {
                                getFileInfo(value).ext === 'pdf' ? (
                                    <ImagePdf>
                                        <PdfIcon/>
                                        <div className={'filename'}>
                                            <span>{window.decodeURIComponent(getFileInfo(value)?.name || "")}</span>
                                            <span>.{getFileInfo(value)?.ext || ""}</span>
                                        </div>
                                    </ImagePdf>
                                ) : (
                                    <img src={value}/>
                                )
                            }
                            {(!value?.url && typeof value !== "string") ? (
                                <SkeletonView style={{width: 120, height: 120}}/>) : null}

                            <EyeIcon className={"open"} onClick={() => {
                                if (isPdf) {
                                    window.open(value, '_blank');
                                } else {
                                    setModalImage(value)
                                }
                            }}/>
                        </Image>
                    )
                })}
            </Images>
            <ViewImageModal style={{display: modalImage ? 'flex' : 'none'}}>
                <ViewImageModalImage>
                    <img src={modalImage} alt={""}/>
                </ViewImageModalImage>
                <ViewImageModalClose onClick={() => setModalImage("")}>
                    <CloseModalIcon/>
                </ViewImageModalClose>
            </ViewImageModal>
        </ImageUploadContainer>
    )
}


export const EmailInput = styled(Input).attrs({
    placeholder: T("Email address")
})`
    border-radius: 10px;
    border: 1px solid #BEBEBE;
    background: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    padding: 0 16px;
    height: 50px;
`;

const PhoneInputContainer = styled.div`
    border-radius: 10px;
    border: 1px solid #BEBEBE;
    background: #FFF;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    display: flex;
    padding: 0 16px;
    height: 50px;

    &.focused {
        border-color: var(--ant-primary-color-hover);
        box-shadow: 0 0 0 2px var(--ant-primary-color-outline);
        border-right-width: 1px;
        outline: 0;
    }
`;
const PhoneInputSelect = styled(Select).attrs({
    suffixIcon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.92 8.17969H11.69H6.07999C5.11999 8.17969 4.63999 9.33969 5.31999 10.0197L10.5 15.1997C11.33 16.0297 12.68 16.0297 13.51 15.1997L15.48 13.2297L18.69 10.0197C19.36 9.33969 18.88 8.17969 17.92 8.17969Z"
                fill="#626262"/>
        </svg>
    )
})`
    width: 82px !important;
    border-right: 1px solid #BEBEBE;

    & .ant-select-selector {
        border: none !important;
        outline: none !important;
        border-radius: 10px;
        padding-left: 0 !important;
        padding-right: 0 !important;
        box-shadow: none !important;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
    }

    & .ant-select-arrow {
        margin-left: 12px;
    }

    & .ant-select-selection-item {
        line-height: 32px !important;
    }
`;
const PhoneN = styled.input`
    border: none !important;
    outline: none !important;
    border-radius: 10px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    padding-left: 12px;
    flex: 1;
`;
const getCodes = () => {
    const codes = [];
    getCountries().map(x => {
        const code = getCountryCallingCode(x).toString();
        if (!codes.find(y => y.code === code)) {
            codes.push({code: code, name: x});
        }
    })

    return codes.sort((a: any, b: any) => {
        a = parseInt(a.code.toString(), 10);
        b = parseInt(b.code.toString(), 10);
        return a > b ? 1 : (b > a ? -1 : 0);
    });
}
const codes = getCodes();
const getCountryName = (code) => {
    return codes.find(x => x.code === code);
}
export const PhoneInput = (props) => {
    const {value, onChange, countryCallingCode} = props;
    const parserValue = value ? parsePhoneNumberFromString(value) : null;
    const [focused, setFocused] = useState(false);
    const [country, setCountry] = useState(parserValue?.countryCallingCode || countryCallingCode || '65')

    const onChangeText = (text, countryNext = "") => {
        const phone = (text || "").replace(/\D/g, '').split(" ").join("").substring(0, 12);
        onChange(`+${countryNext || country}${phone ? parseInt(phone).toString() : ""}`);
    }

    useEffect(() => {
        if (parserValue?.countryCallingCode && parserValue?.countryCallingCode !== country) {
            setCountry(parserValue?.countryCallingCode);
        }
    }, [parserValue?.countryCallingCode]);

    const valueText = formatPhoneNumber((value || "").replace(`+${country}`, ""));

    return (
        <PhoneInputContainer className={focused ? "focused" : ""}>
            <PhoneInputSelect
                value={country}
                onChange={(event: any) => {
                    setCountry(event);
                    onChangeText(valueText, event)
                }}
                onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}>
                {codes.map((item, index) => {
                    return (
                        <Select.Option key={index.toString()} value={item.code}>+{item.code}</Select.Option>
                    )
                })}
            </PhoneInputSelect>
            <PhoneN
                value={valueText || ""}
                onChange={(event) => onChangeText(event.target.value)}
                onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
                placeholder={T("Phone Number")}/>
        </PhoneInputContainer>
    )
}


const PdfIcon = (props: any) => (
    <svg {...props} width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M14.3498 0H33.0725L48.9405 16.5397V48.7097C48.9405 52.7396 45.6802 56 41.6641 56H14.3498C10.3199 56 7.05951 52.7396 7.05951 48.7097V7.29033C7.05944 3.26036 10.3198 0 14.3498 0Z"
              fill="#727C8A"/>
        <path opacity="0.302" fillRule="evenodd" clipRule="evenodd" d="M33.0585 0V16.4138H48.9405L33.0585 0Z"
              fill="white"/>
        <path
            d="M15.1614 41.7831V31.5542H19.5132C20.5907 31.5542 21.4443 31.848 22.088 32.4498C22.7316 33.0375 23.0535 33.8351 23.0535 34.8286C23.0535 35.822 22.7316 36.6197 22.088 37.2074C21.4443 37.8091 20.5907 38.1029 19.5132 38.1029H17.7781V41.7831H15.1614ZM17.7781 35.8781H19.2194C19.6112 35.8781 19.919 35.7941 20.129 35.5982C20.3388 35.4163 20.4508 35.1644 20.4508 34.8286C20.4508 34.4928 20.3389 34.2409 20.129 34.059C19.9191 33.8631 19.6112 33.7792 19.2194 33.7792H17.7781V35.8781ZM24.1309 41.7831V31.5542H27.7551C28.4687 31.5542 29.1404 31.6521 29.7701 31.8621C30.3997 32.0719 30.9735 32.3658 31.4772 32.7716C31.981 33.1634 32.3868 33.6951 32.6806 34.3668C32.9605 35.0385 33.1144 35.8081 33.1144 36.6756C33.1144 37.5292 32.9605 38.2989 32.6806 38.9705C32.3868 39.6422 31.981 40.1739 31.4772 40.5657C30.9734 40.9714 30.3997 41.2653 29.7701 41.4752C29.1404 41.6851 28.4687 41.7831 27.7551 41.7831H24.1309ZM26.6916 39.5582H27.4472C27.853 39.5582 28.2309 39.5163 28.5807 39.4183C28.9165 39.3204 29.2384 39.1664 29.5462 38.9565C29.8401 38.7467 30.0779 38.4528 30.2458 38.061C30.4137 37.6692 30.4977 37.2074 30.4977 36.6756C30.4977 36.1299 30.4137 35.6682 30.2458 35.2764C30.0779 34.8846 29.8401 34.5908 29.5462 34.3808C29.2384 34.171 28.9166 34.017 28.5807 33.9191C28.2309 33.8211 27.853 33.7791 27.4472 33.7791H26.6916V39.5582ZM34.4298 41.7831V31.5542H41.7062V33.7791H37.0465V35.4163H40.7686V37.6272H37.0465V41.7831H34.4298Z"
            fill="white"/>
    </svg>
)

const TrashIcon = (props: any) => (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.5" cx="12" cy="12" r="12" fill="#1B1B1B"/>
        <path
            d="M18.0467 7.48683C16.9733 7.38016 15.9 7.30016 14.82 7.24016V7.2335L14.6733 6.36683C14.5733 5.7535 14.4267 4.8335 12.8667 4.8335H11.12C9.56667 4.8335 9.42 5.7135 9.31334 6.36016L9.17334 7.2135C8.55334 7.2535 7.93334 7.2935 7.31334 7.3535L5.95334 7.48683C5.67334 7.5135 5.47334 7.76016 5.5 8.0335C5.52667 8.30683 5.76667 8.50683 6.04667 8.48016L7.40667 8.34683C10.9 8.00016 14.42 8.1335 17.9533 8.48683C17.9733 8.48683 17.9867 8.48683 18.0067 8.48683C18.26 8.48683 18.48 8.2935 18.5067 8.0335C18.5267 7.76016 18.3267 7.5135 18.0467 7.48683Z"
            fill="white"/>
        <path
            d="M16.82 9.4265C16.66 9.25984 16.44 9.1665 16.2133 9.1665H7.78667C7.56001 9.1665 7.33334 9.25984 7.18001 9.4265C7.02667 9.59317 6.94001 9.81984 6.95334 10.0532L7.36667 16.8932C7.44001 17.9065 7.53334 19.1732 9.86001 19.1732H14.14C16.4667 19.1732 16.56 17.9132 16.6333 16.8932L17.0467 10.0598C17.06 9.81984 16.9733 9.59317 16.82 9.4265ZM13.1067 15.8332H10.8867C10.6133 15.8332 10.3867 15.6065 10.3867 15.3332C10.3867 15.0598 10.6133 14.8332 10.8867 14.8332H13.1067C13.38 14.8332 13.6067 15.0598 13.6067 15.3332C13.6067 15.6065 13.38 15.8332 13.1067 15.8332ZM13.6667 13.1665H10.3333C10.06 13.1665 9.83334 12.9398 9.83334 12.6665C9.83334 12.3932 10.06 12.1665 10.3333 12.1665H13.6667C13.94 12.1665 14.1667 12.3932 14.1667 12.6665C14.1667 12.9398 13.94 13.1665 13.6667 13.1665Z"
            fill="white"/>
    </svg>
)

const CheckBoxIcon = (props: any) => props.type === 'multi' ? (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="18.5" height="18.5" rx="3.25" fill="white"/>
        <rect x="0.75" y="0.75" width="18.5" height="18.5" rx="3.25" stroke="#BEBEBE" strokeWidth="1.5"/>
    </svg>
) : (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="7.25" fill="white" stroke="#BEBEBE" strokeWidth="1.5"/>
    </svg>
)
const CheckedBoxIcon = (props: any) => {
    const {themeColors} = useApp();
    const colorMain = themeColors.main;
    return props.type === 'multi' ? (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="16" height="16" rx="4" fill={colorMain || "#40A68C"}/>
            <path
                d="M12.7355 4.21993C12.8037 4.1503 12.8852 4.09498 12.9751 4.05722C13.065 4.01945 13.1615 4 13.259 4C13.3565 4 13.453 4.01945 13.5429 4.05722C13.6328 4.09498 13.7142 4.1503 13.7825 4.21993C14.0685 4.50893 14.0725 4.97593 13.7925 5.26993L7.87949 12.2599C7.81236 12.3337 7.73089 12.3929 7.64007 12.4341C7.54925 12.4752 7.45099 12.4974 7.3513 12.4993C7.25161 12.5011 7.15258 12.4827 7.06028 12.4449C6.96798 12.4072 6.88435 12.3511 6.81449 12.2799L3.21649 8.63393C3.07773 8.49242 3 8.30213 3 8.10393C3 7.90574 3.07773 7.71545 3.21649 7.57393C3.28474 7.5043 3.36619 7.44898 3.45608 7.41122C3.54597 7.37345 3.64249 7.354 3.73999 7.354C3.83749 7.354 3.93401 7.37345 4.0239 7.41122C4.11379 7.44898 4.19525 7.5043 4.26349 7.57393L7.31549 10.6669L12.7155 4.24193C12.7217 4.23421 12.7284 4.22686 12.7355 4.21993Z"
                fill="white"/>
        </svg>
    ) : (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="8" fill={colorMain || "#40A68C"}/>
            <circle cx="8" cy="8" r="3" fill="white"/>
        </svg>
    )
}

const SearchIcon = (props: any) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M12.4707 11.8776H13.1291L17.2874 16.0443L16.0457 17.2859L11.8791 13.1276V12.4693L11.6541 12.2359C10.7041 13.0526 9.47074 13.5443 8.12907 13.5443C5.1374 13.5443 2.7124 11.1193 2.7124 8.1276C2.7124 5.13594 5.1374 2.71094 8.12907 2.71094C11.1207 2.71094 13.5457 5.13594 13.5457 8.1276C13.5457 9.46927 13.0541 10.7026 12.2374 11.6526L12.4707 11.8776ZM4.37907 8.1276C4.37907 10.2026 6.05407 11.8776 8.12907 11.8776C10.2041 11.8776 11.8791 10.2026 11.8791 8.1276C11.8791 6.0526 10.2041 4.3776 8.12907 4.3776C6.05407 4.3776 4.37907 6.0526 4.37907 8.1276Z"
              fill="#727C8A"/>
    </svg>
)
const RemoveIcon = (props: any) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill="#989898"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M14.383 4.86788C14.6027 5.08755 14.6027 5.4437 14.383 5.66337L10.5381 9.50827L14.383 13.3532C14.6027 13.5728 14.6027 13.929 14.383 14.1487C14.1634 14.3683 13.8072 14.3683 13.5875 14.1487L9.74264 10.3038L5.89775 14.1487C5.67808 14.3683 5.32192 14.3683 5.10225 14.1487C4.88258 13.929 4.88258 13.5728 5.10225 13.3532L8.94714 9.50827L5.10225 5.66338C4.88258 5.44371 4.88258 5.08755 5.10225 4.86788C5.32192 4.64821 5.67808 4.64821 5.89775 4.86788L9.74264 8.71277L13.5875 4.86788C13.8072 4.64821 14.1634 4.64821 14.383 4.86788Z"
              fill="white"/>
    </svg>
)


export const FormPlaceholderLoading = (props) => {
    const {loading} = usePlaceholderLoading();
    if (!loading) {
        return null;
    }
    return (
        <div style={{marginTop: 12, marginBottom: 24, ...(props?.style || {})}}>
            <div style={{display: "flex", alignItems: "center"}}>
                <DivPlaceholder lines={[1]} style={{width: 20, height: 20, borderRadius: 10, marginLeft: 0}}/>
                <div style={{flex: 1, paddingLeft: 6}}><TextPlaceholder lines={[1]} itemStyle={{
                    height: 20,
                    borderRadius: 10,
                    margin: 0
                }}/></div>
            </div>
            <TextPlaceholder lines={[1]} itemStyle={{height: 50, borderRadius: 8}}/>
        </div>
    )
}
